import { openNewbuildingBookingConfirm } from './actions';
import { selectFirstConfirmedPhone, selectIsAuthenticated } from '../../selectors';
import { selectIsBookingSuccess } from '../../selectors/newbuildingBooking';
import { IThunkActionCreator } from '../../store';
import { updateUserData } from '../../store/user';
import { trackBookingPopupShow } from '../../tracking/newbuildingBooking';
import { ETargetType } from '../../types/phoneWarning';
import { requestAuthentication } from '../authentication';
import { openPhoneWarning } from '../phoneWarning';

const openConfirmAction = (): IThunkActionCreator => {
  return (dispatch, getState) => {
    const userPhone = selectFirstConfirmedPhone(getState());

    if (userPhone) {
      dispatch(openNewbuildingBookingConfirm());
      trackBookingPopupShow();
    } else {
      dispatch(openPhoneWarning(ETargetType.Booking));
    }
  };
};

export const openNewbuildingBookingConfirmAction = (): IThunkActionCreator => {
  return async (dispatch, getState, { logger }) => {
    const isAuthenticated = selectIsAuthenticated(getState());
    const isBooked = selectIsBookingSuccess(getState());

    if (!isBooked) {
      if (!isAuthenticated) {
        dispatch(requestAuthentication({ onSuccess: openConfirmAction }));

        return;
      }

      try {
        await dispatch(updateUserData());
      } catch (error) {
        logger.error(error);
      }
    }

    dispatch(openConfirmAction());
  };
};
